import { render } from "./ReportMatchError.vue?vue&type=template&id=cb1e083e&ts=true&lang=pug"
import script from "./ReportMatchError.vue?vue&type=script&lang=ts"
export * from "./ReportMatchError.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__